import getConfig from 'next/config';

const config = getConfig();

const usePublicRuntimeConfig = () => {
  return config.publicRuntimeConfig;
};

export default usePublicRuntimeConfig;
